import React from "react";
import { useNavigate } from "react-router-dom";

const SolutionsItem = ({ imgUrl, header, readMeLink, introText }) => {

  const navigate = useNavigate();

  return (
    <div
      className="w-[300px] h-[400px] mr-12 my-12 bg-slate-200 rounded-md hover:scale-110 transition-all duration-500 cursor-pointer"
    >
      <div>
        <img src={imgUrl} alt="img" className="rounded-t-md" />
      </div>
      <div className="p-4">
        <h6 className="text-lg font-semibold">{header}</h6>
        <p className="w-8 text-sm h-20" title={introText}>{introText}</p>
        <button
          className='w-42 bottom-2 mt-3 px-4 py-1 rounded-md font-semibold'
          size="large"
          onClick={() => navigate(readMeLink)}
        >
          READ MORE
        </button>
      </div>
    </div>
  );
};

export default SolutionsItem;
